import moment from 'moment';
import React, { useState } from 'react';
import { createSearchParams, useLocation, useNavigate } from 'react-router-dom';
import GA, { EVENT_NAMES } from '../../services/googleAnalytics';
import Path from 'app/route/Path';
import { ArrowRightIcon } from '../common/Icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { deleteScalpDataGroup } from '../../services/api/1C';
import { toast } from 'react-toastify';
import ConfirmDeleteDialog from '../CommonDialog/ConfirmDeleteDialog';

export default function BatchDeliveryItem({ data, onDeleted }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [isOpenDialog, setIsOpenDialog] = useState(false);

  const handleDeleteConfirm = async () => {
    try {
      await deleteScalpDataGroup(data._id);
      toast.success('削除成功');
      GA.tracking(EVENT_NAMES.BATCH_DELIVER.DELETE);
      if (onDeleted) {
        onDeleted(data._id);
      }
    } catch (error) {}
  };

  return (
    <>
      <div
        className="w-full h-full relative shadow-center rounded-[12px] p-4 my-4 cursor-pointer flex items-center justify-between"
        onClick={() => {
          GA.tracking(EVENT_NAMES.BATCH_DELIVER.CLICK_DETAIL);
          navigate({
            pathname: Path.batchDeliverScalpLabDetail(data?._id),
            search: createSearchParams({ from: location.pathname + location.search }).toString(),
          });
        }}
      >
        <div>
          <div className="flex gap-2 items-center">
            <div className="bg-gray-base rounded-[34px] text-subtitle px-3 py-1 text-sm">管理番号</div>
            <div>{data.manageCode || ''}</div>
            {/* {data.salonDeliverStatus === 'pending' && (
              <div
                className="pl-4"
                onClick={(e) => {
                  e.stopPropagation();
                  setIsOpenDialog(true);
                }}
              >
                <FontAwesomeIcon icon={faTrash} color="#CACACA" />
              </div>
            )} */}
          </div>
          <div className="flex gap-2 mt-3 items-center text-sm">
            <div>検体数：{data.inspectionKitIds.length || ''}</div>
            <div>
              発送日時：{data.salonDeliverDate ? moment(data.salonDeliverDate).format('YYYY-MM-DD HH:mm') : '未発送'}
            </div>
          </div>
        </div>
        <div>
          <ArrowRightIcon />
        </div>
      </div>

      {isOpenDialog && (
        <ConfirmDeleteDialog
          open={isOpenDialog}
          handleClose={() => setIsOpenDialog(false)}
          confirmTitle={`管理番号 ${data.manageCode} を削除しますか？`}
          confirmTitleAgain="本当に以下の管理番号を全て削除しますか？"
          confirmMessageAgain={data.manageCode}
          deleteCompleteTitle={`管理番号${data.manageCode}を削除しました`}
          deleteCompleteBtnLabel="終了"
          deleteCompleteAction={() => {
            setIsOpenDialog(false);
          }}
          deleteAction={handleDeleteConfirm}
          handleDeleteError={() => {
            setIsOpenDialog(false);
          }}
        />
      )}
    </>
  );
}
